export default __webpack_public_path__ + "static/media/3ad906d36a3392d9f26ac1cc57cec686.jpg";